import React, { useEffect, useState, useRef } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { MobileNavigationEvents } from "../global/MobileNavigationEvents";

import blockImg from "../../images/block-green.svg";
import networkImg from "../../images/network-pink.svg";
import stablecoinsImg from "../../images/stablecoin-purple.svg";

export const Value = () => {
  const [isMobile, setIsMobile] = useState(false);
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [totalSlides, setTotalSlides] = useState(0);

  // Detect mobile view
  useEffect(() => {
    if (typeof window !== "undefined") {
      const checkMobile = () => setIsMobile(window.innerWidth <= 768);
      checkMobile();
      window.addEventListener("resize", checkMobile);
      return () => window.removeEventListener("resize", checkMobile);
    }
  }, []);

  // Update total slides when Splide mounts
  const onSplideMounted = (splide) => {
    setTotalSlides(splide.length);
  };

  const handlePrev = () => sliderRef.current?.splide?.go("-1");
  const handleNext = () => sliderRef.current?.splide?.go("+1");

  const slides = [
    {
      title: "The home of |DeFi  on Bitcoin",
      label: "01",
      description:
        "Some of the best apps and protocols are bringing DeFi to Bitcoin with rBTC, Rootstock’s native Bitcoin asset. From swapping and staking with Sushi, to yield with Beefy and trading with Oku, Rootstock is the home of DeFi on Bitcoin.",
      imgSrc: blockImg,
      bgClass: "bg-green",
      imgWidth: 117, // Custom image width
    },
    {
      title: "Bridged| with major chains",
      label: "02",
      description:
        "Easily bring your assets to Rootstock from over 20 of the leading blockchains including Bitcoin, Ethereum, Arbitrum and Base. Rootstock’s EVM compatibility makes it easy to integrate into existing dApps or build something entirely new. ",
      imgSrc: networkImg,
      bgClass: "bg-pink",
      imgWidth: 130, // Custom image width
    },
    {
      title: "Resilient | & battle tested",
      label: "03",
      description:
        "Rootstock’s network and native bridge, the PowPeg are secured by Bitcoin’s proof-of-work (PoW). This makes Rootstock one of the most reliable blockchains in existence with 100% uptime since launching in 2018.",
      imgSrc: stablecoinsImg,
      bgClass: "bg-purple",
      imgWidth: 100, // Custom image width
    },
  ];

  return (
    <div className="d-flex justify-center align-center pb-lg-16 mt-lg-16 mt-5 pb-11" id="value">
      <div className="container">
        {isMobile ? (
          <>
            <Splide
              ref={sliderRef}
              options={{
                type: "loop",
                perPage: 1,
                perMove: 1,
                gap: "1rem",
                pagination: false,
                arrows: false, // Disable default arrows for mobile
              }}
              onMove={(splide, newIndex) => setCurrentSlide(newIndex + 1)}
              onMounted={onSplideMounted}
            >
              {slides.map((slide, index) => (
                <SplideSlide key={index}>
                  <div
                    className="zg-card d-flex flex-column justify-content-between align-items-start border rounded-4"
                    id="value-prop"
                  >
                    <div>
                      <h3 className="h4 text-black mb-5 d-flex align-items-start">
                        <span className="d-flex flex-column align-items-start me-2">
                          {slide.title.split("|").map((line, i) => (
                            <span
                              key={i}
                              className={`${slide.bgClass} zg-line-height-sm letter-spacing-1 p-2 mb-1`}
                            >
                              {line.trim()}
                            </span>
                          ))}
                        </span>
                        <div className="d-flex align-items-end">
                            <span
                              className={`d-inline-block ${slide.bgClass} px-2 py-1 zg-label`}
                            >
                              {slide.label}
                            </span>
                        </div>
                      </h3>
                      <div className="zg-text-md">
                        <p>{slide.description}</p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end full-width hidden-mobile">
                      <img
                        src={slide.imgSrc}
                        alt="slide illustration"
                        width={slide.imgWidth} // Dynamic width
                        height="auto"
                        loading="lazy"
                        className="hidden-mobile"
                      />
                    </div>
                  </div>
                </SplideSlide>
              ))}
            </Splide>
            {/* Custom Mobile Navigation */}
            <MobileNavigationEvents
              currentSlide={currentSlide}
              totalSlides={totalSlides}
              onPrev={handlePrev}
              onNext={handleNext}
            />
          </>
        ) : (
          <div className="zg-items-grid">
            {slides.map((slide, index) => (
              <div
                key={index}
                className="zg-card d-flex flex-column justify-content-between align-items-start p-4 border rounded-4"
              >
                <div>
                  <h3 className="h4 text-black mb-5 d-flex">
                    <span className="d-flex flex-column align-items-start me-2">
                      {slide.title.split("|").map((line, i) => (
                        <span
                          key={i}
                          className={`${slide.bgClass} zg-line-height-sm letter-spacing-1 p-2 mb-1`}
                        >
                          {line.trim()}
                        </span>
                      ))}
                    </span>
                    <div className="d-flex align-items-end value-tag">
                        <span
                          className={`d-inline-block ${slide.bgClass} px-2 py-1 zg-label`}
                        >
                          {slide.label}
                        </span>
                    </div>
                  </h3>
                  <div className="zg-text-md">
                    <p>{slide.description}</p>
                  </div>
                </div>
                <div className="d-flex justify-content-end full-width">
                  <img
                    src={slide.imgSrc}
                    alt="slide illustration"
                    width={slide.imgWidth} // Dynamic width
                    height="auto"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
